/// <amd-module name="Widgets/TeamMembersWidget/components/PersonaCollection" />
import React = require("react");
import { VssComponent } from "VSS/Platform/Layout";
import { Button } from "VSSUI/Button";
import { IVssPersonaProps, VssPersona } from "VSSUI/VssPersona";
import * as Resources from "Widgets/TeamMembersWidget/Resources";

export interface IPersonaCollectionProps {
    /**
     * Information for each of the persona icons to display.
     */
    personas: IVssPersonaProps[];

    /**
     * The max number of persona icons to display.
     */
    limit: number;

    /**
     * Callback invoked when the user clicks the add button.
     * If this is not provided, then no add button will be shown.
     */
    onClickAddButton?: (event: React.MouseEvent<HTMLElement>) => void;
}

export class PersonaCollection extends VssComponent<IPersonaCollectionProps, {}> {
    public render(): JSX.Element {
        const shouldRenderAddButton: boolean = this.props.onClickAddButton !== undefined;
        return (
            <div className="persona-collection">
                {this.props.personas.slice(0, this.props.limit).map((p, index) => {
                    return (
                        <div className="persona-button" key={index}>
                            <VssPersona {...p} suppressPersonaCard={false} />
                        </div>
                    );
                })}
                {shouldRenderAddButton && this.renderAddButton()}
            </div>
        );
    }

    private renderAddButton(): JSX.Element {
        return (
            <Button
                ariaLabel={Resources.AddButton}
                className="persona-add-button persona-button"
                iconProps={{ iconName: "Add" }}
                onClick={this.props.onClickAddButton}
            />
        );
    }
}
